import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PaymentTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackPaymentResultFunctionArgs {
  readonly orderId: string;
  readonly success: boolean;
}

interface TrackPaymentResultFunction {
  (args: TrackPaymentResultFunctionArgs): void;
}

interface UseTrackPaymentResultFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackPaymentResultFunction {
  (agrs: UseTrackPaymentResultFunctionArgs): TrackPaymentResultFunction;
}

const useTrackPaymentResult: UseTrackPaymentResultFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<PaymentTrackingEvent>();

  const trackPayment: TrackPaymentResultFunction = useCallback(
    ({ orderId, success }) => {
      emitUserEvent({
        event: TrackingEventName.PAYMENT,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        ["payment-success"]: success,
        id: orderId,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackPayment;
};

export { useTrackPaymentResult };
